import diaporama from './components/diaporama';
import carouselImages from './components/sliders/carousel_images';
import videoFrame from './components/video';

diaporama.init();
carouselImages.init();
videoFrame.init();
